<script lang="ts">
  import { fade, scale } from "svelte/transition"
  import { Menu, X, House } from "lucide-svelte"
  import Footer from "$app/Layouts/Footer.svelte"

  import logo from "@images/logo/logo-color.png"

  let showNav = $state(true)
  if (["/pricing", "/signup", "/signup/new"].includes(location.pathname)) {
    showNav = false
  }
  let props = $props()
  let { children } = props

  let signedIn = props.current_user?.id

  let mobileMenuOpen = $state(false)
</script>

<svelte:head>
  <script
    async
    src="https://www.googletagmanager.com/gtag/js?id=G-RXGMN2WVWL"
  ></script>
  <script>
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())

    gtag("config", "G-RXGMN2WVWL")
  </script>
</svelte:head>

<div class="min-h-screen bg-white">
  <div id="navbar" class="sticky top-0 z-50">
    <div class="relative bg-white shadow">
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          class="flex justify-between items-center py-3 md:justify-start md:space-x-10"
        >
          <div class="flex justify-start lg:w-0 lg:flex-1">
            <a href="https://app.leadwithpurpose.com">
              <span class="sr-only">Lead With Purpose</span>
              <img class="h-12 w-auto" src={logo} alt="" />
            </a>
          </div>
          {#if showNav}
            <div class="-mr-2 -my-2 lg:hidden">
              <button
                type="button"
                data-name="mobile-menu"
                onclick={() => (mobileMenuOpen = !mobileMenuOpen)}
                class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                aria-expanded="false"
              >
                <span class="sr-only">Open menu</span>
                <Menu class="h-6 w-6" />
              </button>
            </div>

            <div
              class="hidden lg:flex items-center justify-end lg:flex-1 lg:w-0"
            >
              {#if signedIn}
                <a
                  href="/plans"
                  type="button"
                  class="whitespace-nowrap inline-flex items-center justify-center px-4 py-4 border border-transparent rounded-full shadow-sm text-base text-white bg-green-500 hover:bg-green-700"
                  id="user-menu-button"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  Go To Platform
                </a>
                <a
                  href="/users/sign_out"
                  class="ml-4 lg:ml-6 whitespace-nowrap text-base text-gray-500 hover:text-gray-900"
                >
                  Log Out
                </a>
              {:else}
                <a
                  href="/signup"
                  class="whitespace-nowrap inline-flex items-center justify-center px-4 py-4 border border-transparent rounded-full shadow-sm text-base text-white bg-green-500 hover:bg-green-700"
                  data-name="signup"
                >
                  Start Free Plan
                </a>
                <a
                  href="/signin"
                  data-name="login"
                  class="ml-4 lg:ml-6 whitespace-nowrap text-base text-gray-500 hover:text-gray-900"
                  >Log In</a
                >
              {/if}
            </div>
          {/if}
        </div>
      </div>
    </div>
    {#if mobileMenuOpen}
      <div
        in:scale
        out:fade
        class="absolute top-0 inset-x-0 z-10 p-2 transition transform origin-top-right lg:hidden"
      >
        <div
          class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50"
        >
          <div class="pt-5 pb-6 px-5">
            <div class="flex items-center justify-between">
              <div>
                <img class="h-12 w-auto" src={logo} alt="Lead With Purpose" />
              </div>
              <div class="-mr-2">
                <button
                  type="button"
                  onclick={() => (mobileMenuOpen = !mobileMenuOpen)}
                  class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                >
                  <span class="sr-only">Close menu</span>
                  <X class="h-6 w-6" />
                </button>
              </div>
            </div>
            <div class="mt-6">
              <nav class="grid grid-cols-2 gap-x-4 gap-y-8">
                <a
                  href="/"
                  class="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                >
                  <House class="flex-shrink-0 h-6 w-6 text-gray-600" />
                  <span class="ml-3 text-base font-medium text-gray-900">
                    Home
                  </span>
                </a>
              </nav>
            </div>
          </div>
          <div class="py-6 px-5 space-y-6">
            <div>
              <a
                href="/signup"
                class="w-full flex items-center justify-center px-4 py-3 border border-transparent rounded-lg shadow text-lg font-medium text-white bg-green-500 hover:bg-green-700"
                data-name="signup"
              >
                Start Free Plan
              </a>
              <p class="mt-6 text-center text-base font-medium text-gray-500">
                Existing customer?
                <a
                  href="/signin"
                  data-name="login-mobile"
                  class="text-indigo-600 hover:text-indigo-500">Log In</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>

  <main>
    {@render children()}
  </main>

  <Footer />
</div>
